export function installCardPeek(){
  let current:HTMLElement|null=null,timer:ReturnType<typeof setTimeout>|undefined;
  const peek=document.createElement('div');
  peek.id='card-peek';peek.hidden=true;peek.setAttribute('aria-hidden','true');
  const image=document.createElement('img'),caption=document.createElement('span');
  peek.append(image,caption);document.body.append(peek);
  function hide(){clearTimeout(timer);current=null;peek.hidden=true;}
  function show(card:HTMLElement){
    if(!matchMedia('(hover: hover) and (min-width: 801px)').matches||document.querySelector('dialog[open]'))return;
    clearTimeout(timer);current=card;
    timer=setTimeout(()=>{
      if(current!==card||!card.isConnected)return hide();
      const art=card.querySelector<HTMLImageElement>('img');if(!art)return;
      image.src=art.currentSrc||art.src;image.alt='';caption.textContent=card.getAttribute('aria-label');
      peek.hidden=false;
      const box=card.getBoundingClientRect(),width=peek.offsetWidth,height=peek.offsetHeight;
      const side=box.right+width+20<innerWidth?box.right+12:box.left-width-12;
      peek.style.left=Math.max(12,Math.min(innerWidth-width-12,side))+'px';
      peek.style.top=Math.max(12,Math.min(innerHeight-height-12,box.bottom-height))+'px';
    },180);
  }
  document.addEventListener('pointerover',e=>{const card=(e.target as HTMLElement).closest<HTMLElement>('.catalog-card');if(card&&card!==current)show(card);});
  document.addEventListener('pointerout',e=>{if(current?.contains(e.target as Node)&&!current.contains((e as PointerEvent).relatedTarget as Node))hide();});
  document.addEventListener('focusin',e=>{const card=(e.target as HTMLElement).closest<HTMLElement>('.catalog-card');if(card)show(card);else hide();});
  document.addEventListener('focusout',hide);
  document.addEventListener('pointerdown',hide);
  document.addEventListener('keydown',e=>{if(e.key==='Escape')hide();});
  document.addEventListener('scroll',hide,true);window.addEventListener('resize',hide);
}
